import React from 'react';
import PropTypes from 'prop-types';

import { MAIN_MAP } from '../../../../../redux/map/Constants';
import {
    setAreaFacet,
    setAreaGeojson,
    setAreaFacetValue,
    validateAreaFacetValueAsync
} from '../../../../../redux/search_area/Actions';
import { connect } from 'react-redux';

import SearchAreaInput from './SearchAreaInput';
import { isEqual } from 'lodash';

class SearchArea extends React.Component {
    static propTypes = {
        reducerName: PropTypes.string.isRequired,
        reducerAreaKey: PropTypes.string.isRequired,
        featureKey: PropTypes.string.isRequired,
        heading: PropTypes.string,
        // Redux State
        drawModule: PropTypes.any,
        geojson: PropTypes.object,
        facet: PropTypes.object,
        maxArea: PropTypes.number.isRequired,
        // Redux Dispatch
        dispatchSetAreaFacet: PropTypes.func.isRequired,
        dispatchSetAreaFacetValue: PropTypes.func.isRequired,
        dispatchSetGeojson: PropTypes.func.isRequired,
        dispatchValidateAreaValueAsync: PropTypes.func.isRequired
    };

    static defaultProps = {
        heading: 'Define your area'
    };

    constructor (props) {
        super(props);
    }

    // TODO maybe be best if redux could listen for other redux changes?
    componentDidUpdate (prevProps, prevState, snapshot) {
        const { facet, geojson, dispatchSetGeojson } = this.props;
        if (facet?.layerType === 'drawn' && !isEqual(prevProps.geojson, geojson)) { dispatchSetGeojson(geojson); }
    }

    render () {
        const { classes, dispatchSetGeojson, ...otherProps } =this.props;

        return (
            <SearchAreaInput
                dispatchSetArea={dispatchSetGeojson}
                { ...otherProps }
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const reducer = state[ownProps.reducerName];
    const area = reducer[ownProps.reducerAreaKey];
    let geojson = null;
    const facet = state.lookups.uiData.facetChoices.find(el => el.id === area.facetId);
    if (facet) {
        switch (facet.layerType) {
            case 'all':
                geojson = null;
                break;
            case 'drawn':
                const feature = state[MAIN_MAP].drawingFeature;
                const geometry = feature && feature.geometry;
                geojson = (geometry && geometry.type === 'Polygon') ? feature : null;
                break;
            case 'fixed':
                // ToDo should rename .area to something like geojson since that is what it is
                geojson = area.geojson;
                break;
            default:
                console.error(`Invalid layer type for facet ${facet.name}`);
        }
    }
    
    const featureLayer = state.user.features[ownProps.featureKey].layerId ?
        state.user.features[ownProps.featureKey] :
        state.user.features[ownProps.featureKey].layers.find(layer => layer.layerId === area.layerId)

    return {
        facets: featureLayer?.areaFacets.map(id => state.lookups.uiData.facetChoices.find(fc => fc.id === id)),
        drawModule: state[MAIN_MAP].drawModule,
        maxArea: state.user.features[ownProps.featureKey].maxArea,
        facet: facet,
        facetValue: area.facetValue,
        geojson: geojson
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatchSetAreaFacet: (id) => dispatch(setAreaFacet(ownProps.reducerName, id)),
    dispatchSetAreaFacetValue: (value) => dispatch(setAreaFacetValue(ownProps.reducerName, value)),
    dispatchSetGeojson: (geojson) => dispatch(setAreaGeojson(ownProps.reducerName, geojson)),
    dispatchValidateAreaValueAsync: (facetId, value) => dispatch(validateAreaFacetValueAsync(ownProps.reducerName, facetId, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchArea);